import type { MouseEvent } from 'react';

import type { ApiAddress } from '#/api/types/ApiAddress';
import { H4 } from '#/components/Text/H4';

import { StyledNativeLinkWithRef } from './StyledNativeLinkWithRef';

type Props = {
  address: ApiAddress;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export function AddressLink({ address, onClick }: Props) {
  return (
    <>
      {address.description && (
        <H4 style={{ marginBottom: 0 }}>{address.description}</H4>
      )}

      <StyledNativeLinkWithRef
        href={`https://www.google.com/maps/search/?api=1&query=${encodeURI(
          address.full,
        )}`}
        target="_blank"
        onClick={onClick}
      >
        {address.full}
        {address.line2 && <br />}
        {address.line2}
      </StyledNativeLinkWithRef>
    </>
  );
}
